import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { SPACE_PERMISSIONS_SETTINGS } from '@confluence/named-routes/entry-points/routes';
import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';

export const SpaceAnalyticsPermissionsRoute = ({ params: { spaceKey } }: RouteMatch) => (
	<Redirection href={SPACE_PERMISSIONS_SETTINGS.toUrl({ spaceKey, tab: 'analytics' })} />
);

SpaceAnalyticsPermissionsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled: boolean,
) => ({
	Screen: {
		screenEvent: { name: 'spaceAnalyticsPermissions', id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		spaceKey,
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
	},
});
